import { Endpoint } from '../endpoint';
import { TargetId } from '@business/entities/programs';
import { CommentId, CommentResponse } from '@business/entities/comments';
import { CommonService } from '@business/services';

export function fetchComments(targetId: TargetId ,isCompact?: boolean) {
  return Endpoint.get<CommentResponse[]>(`@makh/comments/${targetId}`, { params: { isCompact } });
}

export function fetchComment(id: CommentId) {
  return Endpoint.get<CommentResponse>(`@makh/comments/comment/${id}`);
}

export function createComment(data: Partial<CommentResponse>) {
  return Endpoint.post<CommentResponse>(`@makh/comments`, { data });
}

export function updateComment(commentId: CommentId, data: Partial<CommentResponse>) {
  return Endpoint.patch<CommentResponse>(`@makh/comments/${commentId}`, { data });
}

export function deleteComment(commentId: CommentId) {
  return Endpoint.delete<void>(`@makh/comments/${commentId}`);
}

export function createCommentFile(data: Partial<any>) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<CommentResponse>(`@makh/comments/comment-file`, { formData, hasFiles: true });
}